import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Navigation from './Navigation';

const drawerWidth = 80;
const radius = 15;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`
    }
  },
  menuButton: {
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: 'rgb(92, 202, 244)',
    border: 'none'
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      paddingTop: theme.spacing(2)
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: theme.spacing(6)
    },
    backgroundColor: '#F6F7F8'
  },
  paper: {
    width: `calc(100% - ${drawerWidth - radius}px)`,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth - radius
    },
    borderRadius: `${radius}px 0px 0px 0px`,
    zIndex: 1001,
    position: 'absolute'
  }
}));

const PrivateLayout = ({ authed, component: Component, ...rest }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  return (
    <Route
      {...rest}
      render={props =>
        authed === true ? (
          <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
              <Hidden smUp implementation="css">
                <Toolbar>
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    className={classes.menuButton}
                  >
                    <MenuIcon />
                  </IconButton>
                </Toolbar>
              </Hidden>
            </AppBar>
            <nav className={classes.drawer} aria-label="Mailbox folders">
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Hidden smUp implementation="css">
                <Drawer
                  variant="temporary"
                  anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  classes={{
                    paper: classes.drawerPaper
                  }}
                  ModalProps={{
                    keepMounted: true
                  }}
                >
                  <Navigation />
                </Drawer>
              </Hidden>
              <Hidden xsDown implementation="css">
                <Drawer
                  classes={{
                    paper: classes.drawerPaper
                  }}
                  variant="permanent"
                  open
                >
                  <Navigation />
                </Drawer>
              </Hidden>
            </nav>
            <Paper className={classes.paper} elevation={0}>
              <main className={classes.content}>
                <Component {...props} />
              </main>
            </Paper>
          </div>
        ) : (
          <Redirect
            to={{ pathname: '/signin', state: { from: props.location } }}
          />
        )
      }
    />
  );
};

PrivateLayout.propTypes = {
  component: PropTypes.any.isRequired,
  authed: PropTypes.bool.isRequired,
  location: PropTypes.object
};

export default PrivateLayout;
